import { FormInstance } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

import { GetUserProfileResponse } from 'src/api/requests'

/** Fills the "Înregistrarea cazului" section of a 058/e or SIDA form:
 *  registration and update date = now, the person who registered = the
 *  current user (name + phone). A field the user already filled is left as
 *  it is, except the update date, which is set to now when editing.
 *  On edit pages, call it after the effect that loads the saved form. */
export const useRegistrationPrefill = (
  form: FormInstance,
  userData?: GetUserProfileResponse,
  enabled = true,
  isEdit = false
) => {
  const fillIfEmpty = (path: string[], value: unknown) => {
    const current = form.getFieldValue(path)
    const isEmpty = current === undefined || current === null || current === ''

    if (value !== undefined && value !== null && value !== '' && isEmpty) {
      form.setFieldValue(path, value)
    }
  }

  useEffect(() => {
    if (!enabled) return

    const now = dayjs()
    fillIfEmpty(['form', 'registration', 'registrationDate'], now)
    if (isEdit) {
      form.setFieldValue(['form', 'registration', 'updateDate'], now)
    } else {
      fillIfEmpty(['form', 'registration', 'updateDate'], now)
    }
  }, [enabled, isEdit])

  useEffect(() => {
    if (!enabled) return

    const fullName = [userData?.firstName, userData?.lastName]
      .filter(Boolean)
      .join(' ')
    fillIfEmpty(['form', 'registration', 'personFullName'], fullName)
    fillIfEmpty(['form', 'registration', 'personPhone'], userData?.phoneNumber)
  }, [enabled, userData?.firstName, userData?.lastName, userData?.phoneNumber])
}
